import React from "react";
import { Alert, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

const TenantContextBanner = () => {
  const navigate = useNavigate();
  const { isSystemUser, activeTenantName, activeTenantId } = useAuth();

  if (!isSystemUser || !activeTenantId) return null;

  return (
    <Alert
      severity="info"
      sx={{
        mb: 2,
        width: "100%",
        alignItems: "center",
        py: 0.5,
        "& .MuiAlert-message": {
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 0.5,
          py: 0.5,
        },
      }}
      action={
        <Button color="inherit" size="small" onClick={() => navigate("/tenantmgmt")}>
          Back to tenants
        </Button>
      }
    >
      <Typography variant="body2" component="span">
        Viewing <strong>{activeTenantName || activeTenantId}</strong> tenant resources
      </Typography>
    </Alert>
  );
};

export default TenantContextBanner;
